import * as React from "react";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import InfoModule from "../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import RemovableList from "../../../hiberUiKit/src/molecules/RemovableList/RemovableList";
import {Option} from "ts-option";
import DropDownWrapper from "../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import * as _ from "underscore";
import CreatableSearchDropDown from "../../../hiberUiKit/src/molecules/SearchDropDown/CreatableSearchDropDown";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import Tag from "../../../model/tag/Tag";
import {Dispatch} from "redux";
import Toast from "../../helper/Toast";
import Job from "../../../model/job/Job";
import {setJobTags} from "../../../store/action/job/job";

interface ComponentProps {
	/**
	 * Job.
	 */
	job: Option<Job>
}

interface IReduxProps {
	/**
	 * Tags
	 */
	tags: Tag[]
}

interface IDispatchProps {
	/**
	 * Add tag to job action
	 * @param {string} jobId
	 * @param {string} tagName
	 */
	setTags: (jobId: string, tags: Tag[]) => void
}


interface IState {
	dropDownVisible: boolean;
}

type Props = ComponentProps & IReduxProps & IDispatchProps

class Tags extends React.PureComponent<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {dropDownVisible: false};
		this.toggleDropdown = this.toggleDropdown.bind(this);
		this.onSelect = this.onSelect.bind(this);
		this.onRemove = this.onRemove.bind(this);
	}

	render() {
		const selectedTags = this.props.job.map(j => j.tags).getOrElse([]);
		const tagsString = _.difference(this.props.tags.map(t => t.name), selectedTags.map(t => t.name));
		const tags = tagsString.map(t => new Tag(t));
		return (
			//TODO Change icon
			<InfoModule icon={Icon.New}
						title={"TAGS"}
						actionIcon={Icon.Add}
						onActionIconClick={this.toggleDropdown}>

				{this.state.dropDownVisible &&
				<DropDownWrapper onOutsideClick={() => this.setState({dropDownVisible: false})}>
					<CreatableSearchDropDown items={tags}
											 onSelect={this.onSelect}
											 itemToLabel={(tag: Tag) => tag.name}
											 itemToId={(tag: Tag) => tag.name}
						//TODO change icon
											 searchInputIcon={Icon.New}
											 newOptionCreator={(text) => new Tag(text)}
											 creatable={true}/>
				</DropDownWrapper>
				}
				{
					selectedTags.length ?
						<RemovableList items={selectedTags}
									   itemRowRenderer={(item: Tag) => item.name}
									   onRemove={this.onRemove}/> :
						<span className="t-body">No tags</span>
				}
			</InfoModule>
		);
	}

	toggleDropdown() {
		this.setState({dropDownVisible: !this.state.dropDownVisible});
	}

	onSelect(tag: Tag) {
		this.toggleDropdown();
		this.props.job.map(j => j.tags.map(t => t.name == tag.name)
			.some(tagExists => tagExists) ? null : this.props.setTags(j.id, j.tags.concat(tag)));
	}

	onRemove(tag: Tag) {
		this.props.job.map(j => {
			const updatedTags = j.tags.filter(t => t.name != tag.name);
			this.props.setTags(j.id, updatedTags);
		})
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		setTags: (jobId: string, tags: Tag[]) => dispatch(
			setJobTags(jobId, tags,
				() => {Toast.success("Job tags updated", "Tags update")},
				() => {Toast.error("Sorry, something went wrong. Try again later.", "Tags update")}))
	}
}

function mapStateToProps(state: RootState) {
	return {
		tags: state.job.tags.getOrElse([])
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Tags)